import type {SelectItemProps} from '@smart/react-components';
import React, {useMemo} from 'react';
import type {Maybe} from '../../graphql';
import {languageMap} from '../common/types';
import {useTranslations} from '../hooks/use-translations';
import {useSchemas} from '../hooks/user-schemas';
import Fields from './easy-form/fields';

interface IProps {
  tag: string;
  required?: boolean;
  label?: Maybe<string>;
  initial?: string;
}

export function CountrySelect({
  tag,
  required,
  label,
  initial,
}: IProps): JSX.Element {
  const generalSchemas = useSchemas();
  const translate = useTranslations();
  const translateCountries = useMemo<SelectItemProps[]>(
    () => [
      {value: ``, label: ``},
      ...Object.keys(languageMap)
        .sort()
        .map((countryCode) => ({
          value: countryCode,
          label: translate(`countries.` + countryCode),
        })),
    ],
    [translate],
  );

  const countriesDropdown = translateCountries.sort((a, b) =>
    a.label ? a.label.localeCompare(b.label || ``) : 0,
  );

  const schema = useMemo(
    () => generalSchemas.oneOf(Object.keys(languageMap), required),
    [translate, translateCountries],
  );

  return (
    <Fields.Select
      initial={initial}
      label={label}
      tag={tag}
      options={countriesDropdown}
      required={required}
      schema={schema}
    />
  );
}
